import { useEffect } from "react";
import { useLocation } from "react-router-dom";

//  ScrollToTop

export default function LocationTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
